import React from "react";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const Loading = () => {
  return (
    <div className="loading-container">
      <FontAwesomeIcon icon={faCog} className="fa-spin loading-spin" />
    </div>
  );
};

export default Loading;
